import { Utils, chains } from '..'

export function getNetworkExplorer(network: Utils.Network): string {
  if (!chains[network]) return ''

  return chains[network].scannerUrl
}
